exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cs-HttpResponse {\n  padding: 20px;\n  line-height: 2em;\n  font-size: 20px;\n  border: 1px solid #ddd;\n  font-family: monospace;\n  background-color: #ffe;\n  color: #666;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/HttpResponse/HttpResponse.less
// module id = 842
// module chunks = 0